import type { ReactNode } from 'react';

import { TabHeader } from '@/shared/ui';

export interface AdminHeaderProps {
    eyebrow: string;
    actions?: ReactNode;
    /** Een blijvende regel over wat de pagina toont ("De klant heeft versie 1 …"). */
    note?: string | null;
    /** Een korte uitkomst van de laatste actie ("Opnieuw verstuurd naar 2 ontvangers."). */
    notice?: { tone: 'status' | 'alert'; text: string } | null;
}

const LINE = 'm-0 text-[13px] leading-[1.5] text-[var(--text-on-dark-2)]';

/**
 * Wat kantoor boven de preview ziet: hoe vaak de pagina bekeken is, de
 * knoppen en wat er met de link gebeurde. Het staat in de kop van de keuring,
 * bij het tabblad Klantpagina; de koper ziet het nooit.
 */
export function AdminHeader({ eyebrow, actions, note, notice }: AdminHeaderProps) {
    return (
        <TabHeader
            status={eyebrow}
            actions={actions}
            notes={
                note || notice ? (
                    <>
                        {note ? <p className={LINE}>{note}</p> : null}
                        {notice ? (
                            <p role={notice.tone} className={LINE}>
                                {notice.text}
                            </p>
                        ) : null}
                    </>
                ) : null
            }
        />
    );
}
